import React from 'react';
import { FaBook, FaTrash } from 'react-icons/fa';
import { useToast } from 'src/hooks/Toast';
import { useSearch } from 'src/hooks/Search';
import FormComponent from 'src/pages/DashboardPages/core/components/FormComponent';
import { convertToXLSX, convertXlsxToJson } from 'src/utils/download';


import { useModal } from '../../../../../../../../hooks/Modal';

import api from '../../../../../../../../services/api';

interface ICreateModule {
    lineData: Record<string, any>;
}

export default function ReviewModule({ project_id }): JSX.Element {

    const { addModal } = useModal();
    const { addToast } = useToast();
    const { reloadSearchAll } = useSearch();


    const removeList = async () => {


        await api.delete(`/remove-avaliations/${project_id}`);
        reloadSearchAll()
        addToast({ title: 'Removido com sucesso', type: 'success' });


    }


    const handleCreate = (): void => {
        const content = <>
            <p>Apagar avaliações?</p>
            <button className='greenButton2' onClick={() => removeList()}>Confirmar remoção</button>

        </>;
        if (content) {
            const keyModal = addModal({ title: 'Adicionar usuários', content, key: 'modal', theme: "whiteModal" });
        }
    };


    const moduleCreate = (): JSX.Element => {

        return <button title='Apagar Avaliações' className='searchButton' onClick={() => handleCreate()}  >

            <FaTrash className="hover" style={{ cursor: 'pointer' }} />

        </button>;
    }



    return moduleCreate();
}
